// extracted by mini-css-extract-plugin
export default {"OtherLoginOptionsContainer":"OtherLoginOptions_OtherLoginOptionsContainer__UsVHm","Buttons":"OtherLoginOptions_Buttons__6AHEx"};